import { Color, Vector2 } from "three";
import { BasePanel } from "./BasePanel";
import VUtil from "../VUILib/VUtils.js";
import { VGridLayout } from "../VUILib/UILayout/VLayout.js";

const bg = "/assets/vrUI/common/bg.png";
const titleBgPath = "/assets/vrUI/common/titleBg.png";
const closeIconPath = "/assets/vrUI/common/close.png";

const save_normalPath = "/assets/vrUI/sceneInfoPanel/save_normal.png";
const save_hoverPath = "/assets/vrUI/sceneInfoPanel/save_hover.png";
const save_clickPath = "/assets/vrUI/sceneInfoPanel/save_click.png";
const delete_normalPath = "/assets/vrUI/sceneInfoPanel/delete_normal.png";
const delete_hoverPath = "/assets/vrUI/sceneInfoPanel/delete_hover.png";
const delete_clickPath = "/assets/vrUI/sceneInfoPanel/delete_click.png";

export class SceneInfoPanel extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  async init() {
    const width = 1;
    const height = 1.2;

    // container
    const bgMap = await this.manager.loadManager.loadTexture(bg);
    const container = this.uilib.createContainer({
      color: 0x0b0c0c,
      map: bgMap,
      opacity: 1,
      width: width,
      height: height,
      radius: 0.025,
      dragable: true,
    });
    this.uilib.addUIToScene(container);
    container.visible = this._visible;
    container.position.x -= 0.5;
    //container.scale.set(0.5, 0.5, 0.5);

    this.uiElements.push(container);

    // title
    const title = this.uilib.createText({
      text: "场景",
      textColor: 0xafbbe3,
      textSize: 0.05,
      font: "bold",
      align: "left",
    });
    container.add(title);
    title.position.y = height / 2 - 0.08;
    title.position.x = -width / 2 + 0.08;

    // close btn
    const closeIcon = await this.manager.loadManager.loadTexture(closeIconPath);
    const closeBtn = this.uilib.createBtn({
      map: closeIcon,
      text: "",
      color: "#A8B4DB",
      width: 0.1,
      height: 0.1,
      radius: 0,
    });
    closeBtn.addHoverEnterEvent((obj) => {
      obj.material.color = new Color("#6275B5");
    });
    closeBtn.addHoverExitEvent((obj) => {
      obj.material.color = new Color("#A8B4DB");
    });
    closeBtn.addClickEvent((obj) => {
      this.closePanel();
    });
    container.add(closeBtn);
    closeBtn.position.z = 0.001;
    closeBtn.position.y = height / 2 - 0.08;
    closeBtn.position.x = width / 2 - 0.11;

    // titleBg
    this.manager.loadManager.loadTexture(titleBgPath, (tex) => {
      const titleBg = this.uilib.createImage({
        map: tex,
        width: width * 0.9,
        height: 0.1,
        radius: 0,
      });
      container.add(titleBg);
      titleBg.position.y = height / 2 - 0.1;
    });

    // save btn
    {
      const save_normal = await this.manager.loadManager.loadTexture(
        save_normalPath
      );
      const save_hover = await this.manager.loadManager.loadTexture(
        save_hoverPath
      );
      const save_click = await this.manager.loadManager.loadTexture(
        save_clickPath
      );
      const saveBtn = this.uilib.createBtn({
        map: save_normal,
        text: "",
        width: 0.12,
        color: 0xffffff,
        height: 0.12,
        radius: 0,
        stateChangeImage: {
          normal: save_normal,
          hover: save_hover,
          click: save_click,
        },
      });
      saveBtn.addHoverEnterEvent((obj) => {});
      saveBtn.addHoverExitEvent((obj) => {});
      saveBtn.addClickEvent((obj) => {});
      container.add(saveBtn);
      saveBtn.position.x = -0.3;
      saveBtn.position.y = 0.375;
      saveBtn.position.z = 0.001;
    }

    // delete btn
    {
      const delete_normal = await this.manager.loadManager.loadTexture(
        delete_normalPath
      );
      const delete_hover = await this.manager.loadManager.loadTexture(
        delete_hoverPath
      );
      const delete_click = await this.manager.loadManager.loadTexture(
        delete_clickPath
      );
      const deleteBtn = this.uilib.createBtn({
        map: delete_normal,
        color: 0xffffff,
        text: "",
        width: 0.12,
        height: 0.12,
        radius: 0,
        stateChangeImage: {
          normal: delete_normal,
          hover: delete_hover,
          click: delete_click,
        },
      });
      deleteBtn.addHoverEnterEvent((obj) => {});
      deleteBtn.addHoverExitEvent((obj) => {});
      deleteBtn.addClickEvent((obj) => {});
      container.add(deleteBtn);
      deleteBtn.position.x = 0.3;
      deleteBtn.position.y = 0.375;
      deleteBtn.position.z = 0.001;
    }

    // line
    const line = this.uilib.createContainer({
      renderOrder: 1000000,
      color: 0xffffff,
      opacity: 0.5,
      width: width * 0.8,
      height: 0.001,
      radius: 0,
      dragable: false,
    });
    container.add(line);
    line.position.y = 0.3;

    // scrollview grid
    {
      const layout = new VGridLayout();
      layout.setCellSize(new Vector2(0.2, 0.2));
      layout.setCountLimit(2);
      layout.setSpacing(new Vector2(0.02, 0.02));
      const grid = this.uilib.createScrollViewGrid({
        renderOrder: 99999,
        opacity: 0.5,
        width: width * 0.8,
        height: 0.8,
        radius: 0,
        gridLayout: layout,
        sliderColor: 0xafbbe3,
        handleColor: 0x8993c3,
        sliderOpacity: 0.5,
        handleOpacity: 0.8,
        sliderExitState: "hide",
      });
      grid.position.y = -0.125;
      container.add(grid);
    }

    if (!this._visible) {
      this.hide();
    }
  }
  closePanel() {
    super.closePanel();
  }
}
